/**
 * Jobs API
 * 职位 API 接口
 */
import client from './client';
import { LegacyJob } from '../../types';
import { convertPostedAtToDate } from '../../shared/utils/jobDataTransform';

// API 返回的是旧格式数据，使用 LegacyJob 类型
type Job = LegacyJob;

export interface JobFilters {
  department?: string;
  type?: string;
  workStyle?: string;
  city?: string;
  country?: string;
  isOpen?: boolean;
  keyword?: string;
}

/**
 * 筛选选项数据结构
 */
export interface FilterOptions {
  departments: Array<{ title: string; count: number }>;
  cities: Array<{
    id: string;
    name: string;
    location: string;
    country: string;
    count: number;
  }>;
  types: Array<{ title: string; count: number }>;
  workStyles: Array<{ title: string; count: number }>;
  locations: Record<string, { city: string; country: string; count: number }>;
  totals: {
    allJobs: number;
    openJobs: number;
    byDepartment: Record<string, { count: number }>;
    byCity: Record<string, { count: number }>;
    byType: Record<string, { count: number }>;
    byWorkStyle: Record<string, { count: number }>;
  };
}

/**
 * 转换 API 数据为 Job 类型
 */
const toJob = (apiJob: any): Job => ({
  ...apiJob,
  postedDate: convertPostedAtToDate(apiJob.postedAt || 'Today'),
});

/**
 * 获取所有职位
 * API 响应格式: { error_code, message, data: Job[] }
 * 响应拦截器返回 response.data，所以这里 response 是 { error_code, message, data }
 */
export const getJobs = async (filters?: JobFilters): Promise<Job[]> => {
  // 拦截器已经返回 response.data，所以这里 response 就是职位数组
  const jobs: any[] = await client.get('/jobs', { params: filters }) || [];
  return jobs.map(toJob);
};

/**
 * 获取单个职位详情
 */
export const getJob = async (id: string): Promise<Job> => {
  // 拦截器已经返回 response.data，所以这里 response 就是职位对象
  return toJob(await client.get(`/jobs/${id}`));
};

/**
 * 获取筛选选项（包含计数和关联关系）
 */
export const getFilterOptions = async (): Promise<FilterOptions> => {
  // 拦截器已经返回 response.data
  return await client.get('/jobs/filters');
};
